import React from "react";
import styles from "./EndStep.module.scss";

const EndStep = () => {
  return (
    <div className={styles.EndStep}>
      <div className={styles.EndStep_Image}>
        <img src="/static/images/helpMe/runBlood.png" alt="runBlood" />
      </div>
      <div className={styles.EndStep_Title}>
        Карточка реципиента отправлена на проверку!
      </div>
      <div className={styles.EndStep_SubTitle}>
        После прохождения модерации карточка появится
        <br />
        на сайте. По всем вопросам пишите нам на почту
      </div>
      <a className={styles.EndStep_Link} href="mailto:support@donorsearch.org">
        <span>support@donorsearch.org</span>
      </a>
    </div>
  );
};

export default EndStep;
